import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { AlertHost } from '@/components/Alertas/AlertHost';

import { Header } from './Header';
import styles from './Layout.module.css';

export function Layout() {
  const { t } = useTranslation(['common', 'nav', 'board', 'articles', 'analytics', 'feeddrive', 'config', 'strategist']);
  void t;
  return (
    <div className={styles.root}>
      <Header />
      {/* Alarmes globais (canto superior direito): toda falha de API sobe
          sozinha via apiFetch → useAlertas, esteja o operador em que tela
          estiver. Antes cada tela escrevia o erro em vermelho no seu canto e
          quem estava noutra aba só descobria pela matéria que não saiu. */}
      <AlertHost />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
